import React, { useState } from 'react';
import AddNewPost from './AddNewPost';
import EditPost from './EditPost';
import {
    Box, Container, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, TablePagination, Typography, Paper, Button
} from '@mui/material';
import { PostListBox } from '../../styles/optionsStyled';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link } from 'react-router-dom';

const PostList = ({ posts }) => {

    const [addNewPost, setAddNewPost] = useState(false);
    const [editPost, setEditNewPost] = useState(false);
    const [editPostId, setEditNewPostId] = useState(null);



    const [page, setPage] = useState(0);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const rowsPerPage = 10;


    const changeAddNewPost = () => {
        setAddNewPost(!addNewPost)
    }

    const changeEditPost = (postId) => {
        setEditNewPost(!editPost);
        setEditNewPostId(postId)

    }




    return (
        <>
            <PostListBox sx={{
                opacity: addNewPost || editPost ? '0.3' : '1',
            }}>
                <Container maxWidth="md" sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    <Link to={'/'}>
                        <ArrowBackIcon sx={{ fontSize: '40px', color: '#fff' }} />
                    </Link>
                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="h4">Post</Typography>  <Button variant='contained' color='success'><Typography variant="button" onClick={changeAddNewPost}>Add Post</Typography> </Button>
                    </Box>
                    <TableContainer component={Paper} sx={{ background: '#012423' }} >

                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell >ID</TableCell>
                                    <TableCell align="right" >Title</TableCell>
                                    <TableCell align="right" >Status</TableCell>
                                    <TableCell align="right" >Category</TableCell>
                                    <TableCell align="right" >Image</TableCell>
                                    <TableCell align="right" >Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody >
                                {posts
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((item, index) => (
                                        <TableRow key={index} sx={{ '&:last-child': { borderBottom: 'none' } }}>
                                            <TableCell >{item.id}</TableCell>
                                            <TableCell sx={{ fontSize: '12px', maxWidth: '150px' }} align="right" >{item.title}</TableCell>
                                            <TableCell align="right" >
                                                < Button disableElevation variant='contained' color='secondary' sx={{ background: item.status === 'publish' ? '#1b5e20' : '#c62828', color: (theme) => theme.palette.text.primary }} >
                                                    {item.status}
                                                </Button>
                                            </TableCell>
                                            <TableCell align="right">
                                                {item.categoryName}
                                            </TableCell>
                                            <TableCell align="right">
                                                <img src={item.featuredImage} width={60} height={40} />
                                            </TableCell>
                                            <TableCell align="right">
                                                <Button variant='contained' color='success' onClick={() => { changeEditPost(item.id) }}>Edit</Button> <Button variant='contained' color='error'>Delete</Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table >
                        <TablePagination
                            component="div"
                            count={posts.length}
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={rowsPerPage}
                        />
                    </TableContainer >
                </Container >
            </PostListBox >
            {addNewPost && <AddNewPost changeAddNewPost={changeAddNewPost} posts={posts} />
            }
            {editPost && <EditPost changeEditPost={changeEditPost} postId={editPostId} />}
        </>
    );
};


export default PostList;
